import { LinearProgress } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useMemo, useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "../Context";

const Step4 = () => {
	const { t } = useTranslation();

	const {
		employees,
		selectedReports,
		selectedEmployees,
		selectedDates,
		reports,
	} = useContext(Context);

	const columns = useMemo(
		() => [
			{
				field: "document_employee",
				headerName: t(
					"custom_reports.execute_reports.stepper.step4.table.columns.person_number"
				),
				flex: 0.6,
				minWidth: 20,
			},
			{
				field: "full_name",
				headerName: t(
					"custom_reports.execute_reports.stepper.step4.table.columns.full_name"
				),
				flex: 1.4,
				minWidth: 150,
			},
			{
				field: "report_name",
				headerName: t(
					"custom_reports.execute_reports.stepper.step4.table.columns.report_name"
				),
				flex: 1,
				minWidth: 150,
			},
			{
				field: "range_date",
				headerName: t(
					"custom_reports.execute_reports.stepper.step4.table.columns.range_date"
				),
				flex: 1,
				minWidth: 150,
			},
		],
		[t]
	);

	const [rows, setRows] = useState([]);

	console.log("Employees:", employees);
	console.log("Reports:", reports);
	console.log("Selected Reports:", selectedReports);
	console.log("Selected Employees:", selectedEmployees);
	console.log("Selected Dates:", selectedDates);

	useEffect(() => {
		const rows = selectedEmployees.map((id) => {
			const emp = employees.find((emp) => emp.id === id);
			const reportIds = selectedReports
				.filter((item) => !item.startsWith("category-"))
				.map((item) => item.split("-")[1]);

			console.log("reportIds:", reportIds);

			const names = reports
				.filter((r) => reportIds.includes(`${r.report_id}`))
				.map((r) => r.name)
				.join(", ");

			console.log("names:", names);

			return {
				...emp,
				range_date: `${selectedDates[0]?.format(
					"YYYY-MM-DD"
				)} - ${selectedDates[1]?.format("YYYY-MM-DD")}`,
				report_name: names,
			};
		});

		console.log("Generated Rows:", rows);

		setRows(rows);
	}, [employees, selectedEmployees, selectedDates, selectedReports, reports]);

	return (
		<>
			<DataGridPro
				showCellVerticalBorder
				showColumnVerticalBorder
				//loading={loadingGettingEmployeeInfo}
				columns={columns}
				rows={rows}
				slots={{
					loadingOverlay: LinearProgress,
				}}
				sx={{
					m: "3.5vw",
					height: `calc(100vh - 450px)`,
				}}
				hideFooter
				disableRowSelectionOnClick
			/>
		</>
	);
};

export { Step4 };
